import React from 'react';
import { useReveal } from '../lib/useReveal';
const PRODUCT_IMG = 'https://cdn.magicpatterns.com/uploads/a3auWVPbY6KNTmUBjM5bbP/ChatGPT_Image_7_may_2026,_11_19_08.png';
const BG_IMG = 'https://cdn.magicpatterns.com/uploads/w6mTwbYbwCmavTPC8PetFK/heylloyd-image-1774029715790.png';
export function HeroSection() {
  const [ref1, vis1] = useReveal();
  return <section className="pt-12 pb-4 md:pt-14 md:pb-6 px-4 sm:px-6 overflow-hidden relative flex flex-col justify-center bg-gradient-to-b from-[#FDF0F3] to-[#FAE8ED]" data-id="element-156">
      {/* Background image */}
      <div className="absolute inset-0 bg-cover bg-center bg-no-repeat opacity-30" style={{
      backgroundImage: `url(${BG_IMG})`,
      mixBlendMode: 'multiply'
    }} data-id="element-157"></div>
      <div className="absolute inset-0 bg-white/40" data-id="element-158"></div>

      <div ref={ref1} className={`reveal container mx-auto max-w-4xl text-center relative z-10 ${vis1 ? 'is-visible' : ''}`} data-id="element-159">
        <div className="mb-2" data-id="element-160">
          <span className="text-brand-accent text-xs md:text-sm font-bold tracking-[0.2em] uppercase" data-id="element-161">
            ⭐ ACADEMIA HOLÍSTICA ARGENTINA ⭐
          </span>
        </div>

        <h1 className="mb-2 font-serif font-bold tracking-tight leading-none text-brand-heading" data-id="element-162">
          <span className="block text-3xl sm:text-4xl md:text-5xl lg:text-6xl mb-2" data-id="element-163">
            MEGAPACK CÓDIGO FÉRTIL
          </span>
        </h1>

        <p className="text-brand-subheading mb-2 max-w-3xl mx-auto leading-relaxed px-2 text-base md:text-xl font-medium" data-id="element-164">
          Tu sistema completo de reconexión femenina. Desde hoy.
        </p>

        <p className="font-display italic font-bold text-xl sm:text-2xl md:text-3xl tracking-wide mb-3 text-brand-accent" data-id="element-165">
          Cuerpo · Emoción · Energía — El método holístico completo
        </p>

        {/* Product Image */}
        <div className="block mx-auto max-w-2xl md:max-w-3xl lg:max-w-4xl mb-3" data-id="element-166">
          <div className="relative animate-float" data-id="element-167">
            <img src={PRODUCT_IMG} alt="MegaPack Código Fértil" className="w-full object-contain block drop-shadow-medium" data-id="element-168" />
          </div>
        </div>

        {/* Pill Badges */}
        <div className="flex flex-wrap justify-center gap-2 sm:gap-3 mb-4" data-id="element-169">
          <span className="flex items-center gap-2 text-xs md:text-sm text-brand-body font-medium bg-white/60 border border-brand-border-soft rounded-full px-3 py-1 backdrop-blur-sm shadow-sm" data-id="element-170">
            📄 100% PDF
          </span>
          <span className="flex items-center gap-2 text-xs md:text-sm text-brand-body font-medium bg-white/60 border border-brand-border-soft rounded-full px-3 py-1 backdrop-blur-sm shadow-sm" data-id="element-171">
            ⚡ Acceso en 5 min
          </span>
          <span className="flex items-center gap-2 text-xs md:text-sm text-brand-body font-medium bg-white/60 border border-brand-border-soft rounded-full px-3 py-1 backdrop-blur-sm shadow-sm" data-id="element-172">
            🇦🇷 Hecho en Argentina
          </span>
        </div>

        {/* CTA */}
        <div className="flex flex-col items-center gap-1.5 w-full max-w-xl mx-auto mb-6" data-id="element-173">
          <a href="#premium" className="w-full block px-4 sm:px-6 py-4 md:py-5 rounded-full text-white font-bold text-sm sm:text-base md:text-lg tracking-wider sm:tracking-widest uppercase transition-all shadow-medium hover:shadow-lg hover:-translate-y-1 bg-brand-cta hover:bg-brand-cta-hover text-center" style={{
          fontFamily: "'Inter', sans-serif"
        }} data-id="element-174">
            → QUIERO MI MEGAPACK AHORA
          </a>
          <p className="text-brand-soft text-xs md:text-sm font-medium mt-2" data-id="element-175">
            🛡️ Garantía 7 días | 🔒 Pago seguro | 💳 Mercado Pago
          </p>
        </div>

        {/* Social Proof Bar */}
        <div className="flex flex-wrap justify-center items-center gap-x-4 gap-y-2 text-xs sm:text-sm text-brand-subheading font-medium border-t border-brand-border-soft pt-4" data-id="element-176">
          <span data-id="element-177">+800 mujeres ya lo tienen</span>
          <span className="hidden sm:inline text-brand-soft" data-id="element-178">•</span>
          <span data-id="element-179">6 Tomos completos</span>
          <span className="hidden sm:inline text-brand-soft" data-id="element-180">•</span>
          <span data-id="element-181">6 Bonos incluidos</span>
          <span className="hidden sm:inline text-brand-soft" data-id="element-182">•</span>
          <span data-id="element-183">⭐ 4.9/5</span>
        </div>
      </div>
    </section>;
}